import React from 'react';
import styles from '../assets/styles/ServiceTypes.module.css';
import { PiGavelFill } from "react-icons/pi";

function ServiceTypes({ header, preamble, typesJson }) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>{header}</div>
      <div className={styles.preamble}>{preamble}</div>
      <div className={styles.typesList}>
        {typesJson.map((item, index) => (
          <div key={index} className={styles.typeItem}>
            <div className={styles.typeTitle}>{item.type}</div>
            <div className={styles.details}>
              <div className={styles.detailBlock}>
                {item.definition}
              </div>
              <div className={styles.detailBlock}>
                <strong><PiGavelFill /> Penalties:</strong> {item.penalties}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ServiceTypes;